import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "es").split("-")[0];
  const toggle = () => i18n.changeLanguage(current === "es" ? "en" : "es");

  return (
    <button
      type="button"
      onClick={toggle}
      className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em]"
      style={{
        color: "var(--text-secondary)",
        padding: compact ? "6px 10px" : "8px 14px",
        border: "1px solid var(--border-subtle)",
        background: "transparent",
      }}
      aria-label={current === "es" ? "Switch to English" : "Cambiar a Español"}
      data-testid="lang-switcher"
      title={current === "es" ? "EN" : "ES"}
    >
      <Globe size={12} />
      {current === "es" ? "EN" : "ES"}
    </button>
  );
}
